<div class="campaign-status-bar" *ngIf="status">
  <div class="status-bar-header">
    <span class="status-label" [ngClass]="'status-' + status.status">{{statusLabel()}}</span>
    <span class="progress-percent">{{status.progress_percent}}%</span>
  </div>
  <mat-progress-bar
    mode="determinate"
    [value]="status.progress_percent"
    [ngClass]="{'status-bar-failed': status.status === 'failed' || status.status === 'partially_failed'}"
  ></mat-progress-bar>
  <div class="status-bar-counts" *ngIf="status.counts">
    <span class="count-item">Intended: {{displayCount(status.counts.intended)}}</span>
    <span class="count-item">Accepted (SMTP): {{displayCount(status.counts.accepted)}}</span>
    <span class="count-item">Failed: {{displayCount(status.counts.failed)}}</span>
    <span class="count-item">Unknown: {{displayCount(status.counts.unknown)}}</span>
    <span class="count-item">Delivered: {{displayCount(status.counts.delivered)}}</span>
  </div>
  <p class="status-bar-warning" *ngFor="let w of status.warnings">{{w}}</p>
  <p class="status-bar-error" *ngIf="status.last_error">{{status.last_error}}</p>

  <p class="status-bar-meta" *ngIf="!isTerminal && !isGivenUp">
    <span class="polling-dot" [class.polling-dot-stale]="isStalled"></span>
    Checking for updates every {{status.recommended_poll_interval_ms ? (status.recommended_poll_interval_ms / 1000) : 1.5}}s
    &middot; last update {{secondsSinceUpdate}}s ago
  </p>
  <p class="status-bar-stall" *ngIf="isStalled && !isGivenUp">
    No new counts in over {{secondsSinceUpdate}}s. The campaign is very likely still processing
    server-side (this bar keeps polling automatically) - it is not necessarily stuck.
  </p>
  <p class="status-bar-poll-error" *ngIf="pollError && !isGivenUp">
    Trouble reaching the server ({{pollError}}) - still retrying automatically, showing the last known status above.
  </p>
  <p class="status-bar-poll-failed" *ngIf="isGivenUp">
    Unable to check the campaign's status ({{pollError}}) - gave up after repeated failures. The status above is the
    last one confirmed and may be out of date. Reopen this campaign to try checking again.
  </p>
</div>
